import React from "react";
import PropTypes from "prop-types";
import { Grid, Button } from "semantic-ui-react";
import Link from "next/link";
import { Title, Segmant, ImageItem, CustomFeed } from "../../components";

const Activities = ({
  activityData,
  onClick,
  usertype,
  display,
  iseditor,
  ...props
}) => {
  return (
    <Grid stackable>
      {activityData.map((activity, index) => (
        <Grid.Row key={index}>
          <Grid.Column width={5}>
            {/* <Link {...props}>
              <a style={{ cursor: 'pointer' }} target="_blank">
                <ImageItem src={activity.image} />
              </a>
            </Link> */}
            <>
              {activity.nhimages.length > 0 ? (
                <>
                  <Link
                    {...props}
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    href={`/Neighborhood/${activity.nhfullname}`}
                    title={activity.nhfullname}
                  >
                    {/* <a
                      style={{ cursor: "pointer" }}
                      target="_blank"
                      href={`/Neighborhood/${activity.nhfullname}`}
                      title={activity.nhfullname}
                    > */}
                    <div className="realtor_nh_images">
                      <ImageItem
                        src={activity.nhimages[0].imageurl}
                        alt="Neighborhood Image"
                        title="Neighborhood Image"
                      />
                    </div>
                    {/* </a> */}
                  </Link>
                </>
              ) : (
                <Link
                  {...props}
                  style={{ cursor: "pointer" }}
                  target="_blank"
                  title="Neighborhood Image"
                >
                  {/* <a
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    title="Neighborhood Image"
                  > */}
                  <div className="realtor_nh_images">
                    <ImageItem
                      src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultadd.jpg`}
                      alt="Neighborhood Image"
                      title="Neighborhood Image"
                    />
                  </div>
                  {/* </a> */}
                </Link>
              )}
            </>
          </Grid.Column>
          <Grid.Column width={11}>
            <Link
              {...props}
              style={{ cursor: "pointer" }}
              target="_blank"
              href={`/Neighborhood/${activity.nhfullname}`}
            >
              {/* <a
                style={{ cursor: "pointer" }}
                target="_blank"
                href={`/Neighborhood/${activity.nhfullname}`}
              > */}
              <Title
                color="blue"
                name={activity.heading.replace("Review on", "")}
              />
              {/* </a> */}
            </Link>
            {typeof activity.review == "object" ? (
              <div>
                {!activity.review ? null : activity.review.length <= 3 ? (
                  <Segmant>
                    {activity.review.map((data, index) => (
                      <div style={{ paddingTop: 10 }} key={index}>
                        <CustomFeed
                          date={data.rdate}
                          head={data.head1}
                          data={data.review}
                        />
                        <CustomFeed data={data.written} />
                      </div>
                    ))}
                  </Segmant>
                ) : display[index] ? (
                  <div>
                    <Segmant>
                      {activity.review.slice(0, 6).map((data, index) => (
                        <div style={{ paddingTop: 10 }} key={index}>
                          <CustomFeed
                            date={data.rdate}
                            head={data.head1}
                            data={data.review}
                            nhid={activity.nhfullname}
                          />
                          <CustomFeed data={data.written} />
                        </div>
                      ))}
                    </Segmant>
                    <span
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        width: "100%",
                      }}
                      onClick={(e) => onClick(e, index)}
                    >
                      <Title
                        name="Show Less"
                        color="black"
                        size="small"
                        floated="right"
                      />
                    </span>
                  </div>
                ) : (
                  <div>
                    <Segmant>
                      {activity.review.slice(0, 3).map((data, index) => (
                        <div style={{ paddingTop: 10 }} key={index}>
                          <CustomFeed
                            date={data.rdate}
                            head={data.head1}
                            data={data.review}
                            nhid={activity.nhfullname}
                          />
                          <CustomFeed
                            data={data.written}
                            nhid={activity.nhfullname}
                          />
                        </div>
                      ))}
                    </Segmant>
                    <span
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        width: "100%",
                      }}
                      onClick={(e) => onClick(e, index)}
                    >
                      <Title
                        name="Show More"
                        color="black"
                        size="small"
                        floated="right"
                      />
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <Segmant>
                {/* <CustomFeed
                  date={activity.createDate}
                  head="Reviews :"
                  data={activity.review}
                /> */}
                <CustomFeed
                  className="realtor-summary-wrapper"
                  data={activity.heading}
                  head={<div>Reviews:</div>}
                  date={activity.createDate}
                  nhid={activity.nhfullname}
                />
              </Segmant>
            )}
            {usertype === "realtor" && !iseditor && (
              <div style={{ textAlign: "right" }}>
                <a
                  href={`/PrintFlyer/?id=${activity.NeighborhoodID}`}
                  target="_blank"
                  className="print_flyer"
                >
                  Print flyer
                </a>
              </div>
            )}
            {usertype === "realtor" && iseditor && (
              <div style={{ textAlign: "right" }}>
                <a
                  href={`/PrintFlyerEditor/${activity.nhfullname}`}
                  target="_blank"
                  className="print_flyer"
                >
                  Print flyer
                </a>
              </div>
            )}

            {activity.questions.length > 0 ? (
              <div>
                {!activity.questions ? null : activity.questions.length <= 3 ? (
                  <Segmant>
                    <CustomFeed
                    //date={data.date}
                    //head="Questions:"
                    //data={data.question}
                    />
                    {activity.questions.map((data, index) => (
                      <div style={{ paddingTop: 10 }} key={index}>
                        {data.question != "$context.arguments.question" && (
                          <CustomFeed
                            className="realtor-summary-wrapper"
                            date={data.lastUpdated}
                            head={index === 0 ? <div>Questions:</div> : ""}
                            data={data.question}
                            nhid={activity.nhfullname}
                          />
                        )}
                        <CustomFeed
                          data={data.answer}
                          nhid={activity.nhfullname}
                        />
                      </div>
                    ))}
                  </Segmant>
                ) : display[index] ? (
                  <div>
                    <Segmant>
                      {activity.questions.slice(0, 6).map((data, index) => (
                        <div style={{ paddingTop: 10 }} key={index}>
                          <CustomFeed
                            className="realtor-summary-wrapper"
                            date={data.lastUpdated}
                            head={index === 0 ? "Questions:" : ""}
                            data={data.question}
                            nhid={activity.nhfullname}
                          />
                          <CustomFeed
                            data={data.answer}
                            nhid={activity.nhfullname}
                          />
                        </div>
                      ))}
                    </Segmant>
                    <span
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        width: "100%",
                      }}
                      onClick={(e) => onClick(e, index)}
                    >
                      <Title
                        name="Show Less"
                        color="black"
                        size="small"
                        floated="right"
                      />
                    </span>
                  </div>
                ) : (
                  <div>
                    <Segmant>
                      {activity.questions.slice(0, 3).map((data, index) => (
                        <div style={{ paddingTop: 10 }} key={index}>
                          <CustomFeed
                            className="realtor-summary-wrapper"
                            date={data.lastUpdated}
                            head={index === 0 ? "Questions:" : ""}
                            data={data.question}
                            nhid={activity.nhfullname}
                          />
                          <CustomFeed
                            data={data.answer}
                            nhid={activity.nhfullname}
                          />
                        </div>
                      ))}
                    </Segmant>
                    <span
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        width: "100%",
                      }}
                      onClick={(e) => onClick(e, index)}
                    >
                      <Title
                        name="Show More"
                        color="black"
                        size="small"
                        floated="right"
                      />
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <Segmant>
                {/* <CustomFeed
                  //date={activity.qdate}
                  head="Questions :"
                  data="No Questions for this neighborhood"
                /> */}
                {/* <CustomFeed data={activity.answer} /> */}
              </Segmant>
            )}
          </Grid.Column>
        </Grid.Row>
      ))}
    </Grid>
  );
};

Activities.propTypes = {
  activityData: PropTypes.array.isRequired,
};

export default Activities;
